'use client';

import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { handleLogin } from './actions';

export default function LoginPage() {
  const [error, setError] = useState('');
  const router = useRouter();

  async function handleSubmit(formData: FormData) {
    const success = await handleLogin(formData);
    if (success) {
      router.push('/admin');
    } else {
      setError('Invalid credentials');
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-white py-12 px-8">
      <div className="max-w-md w-full space-y-12">
        {/* Header - Minimal */}
        <div className="text-center">
          <h2 className="text-2xl font-heading font-normal tracking-tight text-[#151515]">
            Admin Login
          </h2>
          <div className="w-16 h-px bg-[#E2E2E2] mx-auto mt-6"></div>
        </div>

        {/* Form - Clean */}
        <form className="space-y-6" action={handleSubmit}>
          <div className="space-y-4">
            <div>
              <label htmlFor="email-address" className="block text-xs font-light tracking-[0.1em] uppercase text-[#151515] opacity-60 mb-2">
                Email
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                required
                className="w-full px-4 py-3 border border-[#E2E2E2] text-[#151515] text-sm focus:outline-none focus:border-[#151515] transition-colors"
                placeholder="your@email.com"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-xs font-light tracking-[0.1em] uppercase text-[#151515] opacity-60 mb-2">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="w-full px-4 py-3 border border-[#E2E2E2] text-[#151515] text-sm focus:outline-none focus:border-[#151515] transition-colors"
                placeholder="••••••••"
              />
            </div>
          </div>

          {/* Error Message */}
          {error && (
            <div className="text-[#ee3b45] text-xs font-light tracking-wide text-center py-2">
              {error}
            </div>
          )}

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#151515] text-white py-4 text-xs font-light tracking-[0.15em] uppercase hover:opacity-80 transition-opacity"
          >
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
}
